import Translate from "src/ui/components/Translate/Translate";
import { ProfileProgramMembership } from "src/constants/programs";
import GoalHWJ from "src/ui/assets/images/graph-weight-loss.webp";
import GoalEDJ from "src/ui/assets/images/graph-a1c.webp";
import GoalHWJSpanish from "src/ui/assets/images/graph-weight-loss-es.webp";
import GoalEDJSpanish from "src/ui/assets/images/graph-a1c-es.webp";
import { getSupportedUserLanguage } from "src/lib/i18next";
import Language from "src/constants/language";
import styled from "@emotion/styled";

const SlideWrapper = styled.div`
  margin: 0 auto;
  max-width: var(--content-width);
`;

const Title = styled.h1`
  font-size: var(--title-font-size, 2.25rem);
  margin-bottom: 0.5em;
  text-align: center;
`;

const GoalsContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const GoalImage = styled.img`
  display: block;
  margin-bottom: 1.5rem;
`;

const GoalDescription = styled.p`
  font-size: 1rem;
  text-align: center;
  color: var(--color-gray-700, #374151);
  line-height: 1.5;
  letter-spacing: -0.02em;
  max-width: 442px;
`;

interface ExpectationsManagementGoalsProps {
  programMembership?: ProfileProgramMembership;
}

const ExpectationsManagementGoals = ({
  programMembership
}: ExpectationsManagementGoalsProps) => {
  const isEDJ =
    programMembership === ProfileProgramMembership.EVERYDAY_DIABETES_JOURNEY;
  const isSpanish = getSupportedUserLanguage() === Language.es;

  const goalImagesByProgram = {
    EDJ: { en: GoalEDJ, es: GoalEDJSpanish },
    HWJ: { en: GoalHWJ, es: GoalHWJSpanish }
  };

  const context = isEDJ ? "EDJ" : "HWJ";
  const imageSrc = goalImagesByProgram[context][isSpanish ? "es" : "en"];

  return (
    <SlideWrapper>
      <Title>
        <Translate msg="onboardingExpectation.goal.title" />
      </Title>
      <GoalsContent>
        <GoalImage src={imageSrc} alt="Expectation management goal" />
        <GoalDescription>
          <Translate
            msg="onboardingExpectation.goal.description"
            variables={{ context }}
          />
        </GoalDescription>
      </GoalsContent>
    </SlideWrapper>
  );
};

export default ExpectationsManagementGoals;
